<template>
  <div id="slide-8" class="slide">
    <img src="../assets/images/main-line-4.svg" alt="main-line-4" class="line-img main-line-4">
    <div class="container slide-content">
      <div class="row">
        <div class="col-md-8 offset-md-2 col-sm-12">
          <h1 class="is-pink mb-4" v-if="shared">Thank you for sharing!</h1>
          <h1 class="is-pink mb-4" v-else>No problem, thanks for taking part.</h1>
          <p class="p-20 is-bold">Visit Talk London now and have your say on big issues in the capital, including housing, environment, culture and more.</p>
          <div class="btn-wrapper">
            <a target="_blank" href="https://www.london.gov.uk/talk-london/user/register?destination=node/5" class="btn btn-purple">Join the community</a>
          </div>
          <p class="p-20 is-bold">To keep up-to-date with what’s going on in the capital, follow London Gov on social media: </p>
          <div class="btn-wrapper">
            <a target="_blank" href="https://www.facebook.com/LDNgov/" class="btn btn-facebook" @click="follow($event)">Follow on Facebook</a>
            <a target="_blank" href="https://twitter.com/LDN_gov" class="btn btn-twitter" @click="follow($event)">Follow on Twitter</a>
          </div>
          <p class="refresh p-20" @click="refresh">Or try entering a different journey</p>
        </div>
      </div>
    </div>
    <div class="mob-space-bottom"></div>
    <img src="../assets/images/main-line-1.svg" alt="mobile-line-1" class="mobile-line-img mobile-line-1">
  </div>
</template>

<script>
export default {
  props: ['talkLondon', 'shared'],
  data() {
    return {
    }
  },
  methods: {
    follow(event) {
      this.$ga.event('FA - data journey', 'Follow', event.target.innerHTML);
    },

    refresh() {
      window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
  .refresh {
    margin-top: 30px;
    text-decoration: underline;
    cursor: pointer;
  }

  h2,
  p {
    width: 80%
  }

  .main-line-4 {
    position: absolute;
    bottom: 0;
    left: 100px;
  }

  .btn-purple {
    margin-top: 20px;
    padding: 12px 45px;
  }

  .btn-wrapper {
    display: flex;
    margin: 0 -10px;
  }

  .btn-wrapper .btn-purple {
    flex: 0 0 50%;
    margin: 20px 10px 30px;
    text-align: center;
    padding: 12px 20px;
  }

  .btn-facebook,
  .btn-twitter {
    flex-grow: 1;
    margin: 20px 10px 0;
  }

  @media screen and (max-width: 1200px) {
    .main-line-4 {
      left: 60px;
    }
  }

  @media screen and (max-width: 992px) {
    .main-line-4 {
      left: 60px;
    }

    h2,
    p {
      width: 100%
    }

    .btn-wrapper {
      display: block;
      margin: 0;
    }

    .btn-wrapper .btn-purple,
    .btn-facebook,
    .btn-twitter {
      display: block;
      margin: 0 0 20px;
      padding: 16px 0;
      font-size: 24px;
    }
  }

  @media screen and (max-width: 900px) {
    .main-line-4 {
      display: block;
      right: 0;
      left: 0;
      margin: auto;
      bottom: -200px;
    }
  }


  @media screen and (max-width: 767px) {
    .main-line-4 {
      display: none;
    }

    .slide-content {
      margin-top: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Slide8.vue